//**auto-generated don't edit this code**//
export enum SuggestedGradeLevel {
	None,
	PreK,
	TK,
	K,
	GradeOne,
	GradeTwo,
	GradeThreePlus,
}